// extracted by mini-css-extract-plugin
export default {"costDiscount":"LeadList_costDiscount__0rI3u"};